export enum RequestAutomationType {
  AI_SCREEN = 'AiScreen',
  FOR_EVERY_NEW_PROVIDER = 'ForEveryNewProvider',
  FOR_PROVIDERS_IN_CATEGORY = 'ForProvidersInCategory',
}
